import axiosInstance from "./AxiosInstance";

// Get Admin Users
export function getAdminUsers(pagination, pageid,search_by = "", search_keyword = "",sort_by = "",sort_order="") {
  return axiosInstance.post("/admin/adminList", { pagination, pageid ,    search_by, search_keyword,sort_by,sort_order});
}

// Add Admin User
export function addAdminUser(userData) {
  return axiosInstance.post("/admin/addAdmin", userData);
}

// ✅ Update Admin User
export function updateAdminUser(userData) {
  return axiosInstance.post("/admin/editAdmin", userData);
}

// ✅ Delete Admin User
export function deleteAdminUser(userData) {
  console.log("deleteAdminUser payload:", userData);
  return axiosInstance.post("/admin/deleteAdmin", userData);
}

// ✅ Format Admin Users
export function formatAdminUsers(responseData) {
  if (!responseData) return [];

  if (Array.isArray(responseData)) {
    return responseData.map((user) => ({
      ...user,
      admin_id: user.admin_id || user._id || user.id,
    }));
  }

  let users = [];
  for (let key in responseData) {
    if (responseData.hasOwnProperty(key)) {
      users.push({
        ...responseData[key],
        admin_id:
          responseData[key].admin_id ||
          responseData[key]._id ||
          responseData[key].id ||
          key,
      });
    }
  }
  return users;
}
